import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logoBlack from './logo_black_and_white_256x256.png';
import './WelcomePage.css';
import LoginPage from './LoginPage';
import RegisterPage from './RegisterPage';
import { useAuth } from './context/AuthContext';

const WelcomePage = ({ showModal }) => {
  const [modal, setModal] = useState(showModal);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.showLogin) {
      setModal('login');
    }
  }, [location.state]);

  const handleClose = () => {
    setModal(null);
    navigate('/welcome');
  };

  return (
    <div className="auth-container">
      <header className="App-header">
        <img src={logoBlack} className="App-logo" alt="logo" />
        <h1>Plan your meals</h1>
      </header>
      <div className="welcome-content">
        <h2>Welcome to your new meal planning app!</h2>
        <p>Organize recipes, create meal plans, and generate shopping lists with ease.</p>
        <div className="welcome-actions">
          <button title="Login" onClick={() => setModal('login')} className="button"><i className="material-icons">login</i>Login</button>
          <button title="Register" onClick={() => setModal('register')} className="button button-secondary"><i className="material-icons">person_add</i>Register</button>
        </div>
      </div>
      {modal === 'login' && <LoginPage onLogin={login} onClose={handleClose} />}
      {modal === 'register' && <RegisterPage onClose={handleClose} />}
    </div>
  );
};

export default WelcomePage;
